module.exports = __webpack_public_path__ + "static/img/logoBG.3ac819d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoBG.png
// module id = 583
// module chunks = 70